import {
  CallIntelligenceService,
  GetServiceQualityStatsRequest,
} from '@weave/schema-gen-ts/dist/schemas/call-intelligence/v2';
import { MockPersons } from '@frontend/api-person';
import { DemoInterceptorUtils, FeatureMockRouter } from '@frontend/demo-interceptors';
import { serviceName } from '../../service';
import { BaseMockRouterContext } from './types';

export interface CallIntelServiceQualityMockRouterContext extends BaseMockRouterContext {
  mockPersonsInstance: MockPersons;
}

export const CallIntelServiceQualityMockRouter: FeatureMockRouter<CallIntelServiceQualityMockRouterContext> = {
  getRequestInterceptors: ({ interceptorIdPrefix }) => {
    return [
      {
        id: `${interceptorIdPrefix}-service-quality-stats`,
        interceptor: async (request) => {
          const isMatching = await DemoInterceptorUtils.isMatchingApiEndpoint({
            method: request.method,
            requestUrl: request.url,
            schemaMethod: CallIntelligenceService.GetServiceQualityStats,
          });

          if (isMatching) {
            const requestBody: GetServiceQualityStatsRequest = await request.clone().json();
            requestBody.isDemo = true;

            return new Request(request, {
              body: JSON.stringify(requestBody),
            });
          }
          return request;
        },
      },
    ];
  },
  invalidateQueries: (queryClient) => {
    queryClient.invalidateQueries([serviceName, 'GetServiceQualityStats']);
  },
};
